var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[(_vm.me.info && _vm.$store.state.form.formDisplayOptions.notePosition=='above-answer')?_c('div',{staticClass:"info-text"},[_c('i',{staticClass:"mdi mdi-information-outline mr-1"}),_c('span',{domProps:{"innerHTML":_vm._s(_vm.me.info)}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }